/**
 * Date functions.
 */
export const DateService = {
  /**
   * One day in milliseconds.
   */
  ONE_DAY: 1000 * 60 * 60 * 24,

  /**
   * Returns the number of days elapsed between two timestamps.
   *
   * @param {number} datestamp1 Timestamp to subtract from.
   * @param {number} datestamp2 Timestamp to subtract.
   * @return {number} Difference in days between the two timestamps.
   */
  daysElapsed(datestamp1: number, datestamp2: number): number {
    return Math.floor((datestamp1 - datestamp2) / this.ONE_DAY);
  },

  /**
   * Returns the number of days elapsed since the specified timestamp.
   *
   * @param {number} timestamp The timestamp to calculate how many days elapsed since.
   */
  daysElapsedSince(timestamp: number): number {
    return this.daysElapsed(Date.now(), timestamp);
  }
};
